import Pong from './Pong.svelte';
const app = new Pong({
    target: document.body,
});
export default app;
